import { User } from "./types/user.types";

export const userIsAdmin = (user: User | null | undefined): boolean => {
	if (user == undefined) {
		return false;
	}
	return user.isSuperAdmin;
};
